import {
  Component,
  OnInit,
  Injector,
  OnDestroy,
  ViewEncapsulation,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ReactiveFormsModule,
} from "@angular/forms";

import { Router, ActivatedRoute } from "@angular/router";
const swal = require("sweetalert");
import * as ptLocale from "date-fns/locale/pt";
import { BehaviorSubject } from "rxjs";
import { LoadingService } from "../../../../util/loader.service";
import { CustomValidators } from "ng2-validation";
import { DatepickerOptions } from "ng2-datepicker";

import { List } from "lodash";
import { Empresa } from "../../../../models/empresa/empresa";
import { MultiplasLojasService } from "../multiplas-lojas.service";

@Component({
  selector: "app-form-empresa",
  templateUrl: "./form-empresa.component.html",
  styleUrls: ["./form-empresa.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class FormEmpresaComponent implements OnInit {
  valForm: FormGroup;
  buttonType: any;

  router: Router;
  id: any;
  empresa: Empresa;
  edicao = false;




  constructor(
    public service: MultiplasLojasService,
    public injector: Injector,
    fb: FormBuilder,
    private route: ActivatedRoute,
    private routerNavigate: Router,
    public loader: LoadingService
  ) {
    // INTANCIA O OBJETO
    this.empresa = new Empresa();

   

    this.id = this.route.snapshot.paramMap.get("id");
    if (this.id !== undefined && this.id != null) {
      //this.loader.show("body");
      /* this.service.obterPorCodigo(this.id)
        .subscribe(itens => {
          this.loader.hide('body');
          this.empresa = itens;
        });*/
      this.edicao = true;
    } else {
      this.edicao = false;
    }

  }

  
  ngOnInit() {}
}
